import request from '@/utils/request'
const BASE_URL = '/User'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  login(data) {
    return request({
      url: BASE_URL + '/Login',
      method: 'post',
      data
    })
  },
  loginByMobile(data) {
    return request({
      url: BASE_URL + '/LoginByMobile',
      method: 'post',
      data
    })
  },
  loginByCode(data) {
    return request({
      url: BASE_URL + '/LoginByCode',
      method: 'post',
      data
    })
  },
  sendCode(mobile) {
    return request({
      url: BASE_URL + '/SendCode',
      method: 'post',
      data: mobile
    })
  },
  logout() {
    return request({
      url: BASE_URL + '/Logout',
      method: 'post',
    })
  },
  forceLogout(data) {
    return request({
      url: BASE_URL + '/ForceLogout',
      method: 'post',
      data
    })
  },
  refreshToken(data) {
    return request({
      url: BASE_URL + '/RefreshToken',
      method: 'post',
      data
    })
  },
  getPermission() {
    return request({
      url: BASE_URL + '/GetPermission',
      method: 'post'
    })
  },
  changePwd(data) {
    return request({
      url: BASE_URL + '/ChangePwd',
      method: 'post',
      data
    })
  },
  getVerCode() {
    return request({
      url: BASE_URL + '/GetVerCode',
      method: 'get',
    })
  },
  online() {
    return request({
      url: BASE_URL + '/Online',
      method: 'get',
    })
  },
  getRandomOriginal() {
    return request({
      url: BASE_URL + '/GetRandomOriginal',
      method: 'get',
    })
  },
  certAuth(data) {
    return request({
      url: BASE_URL + '/CertAuth',
      method: 'post',
      data
    })
  },
  certLogin(data) {
    return request({
      url: BASE_URL + '/CertLogin',
      method: 'post',
      data
    })
  },
  getAuth() {
    return request({
      url: BASE_URL + '/GetAuth',
      method: 'get',
    })
  },
  getWorkbench() {
    return request({
      url: BASE_URL + '/GetWorkbench',
      method: 'get',
    })
  },
}